// NEXT_PUBLIC_* はビルド時インライン化のため必ずアプリコードで参照する。
// 検証・normalize・dev フォールバックはパッケージ側が使用時に行う
// （env 未設定の production = 現状の stg でモジュール評価時にクラッシュさせないため、ここでは raw 値のまま）。
export const csChatWorkerBaseUrl =
  process.env.NEXT_PUBLIC_SUNSUN_CHAT_BASE_URL ??
  process.env.NEXT_PUBLIC_CHAT_WORKER_URL;
